import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';

export const useSentryInitUser = () => {
  const { foundUser } = useSelector((state) => state.authentication);

  useEffect(() => {
    if (foundUser) {
      Sentry.setUser({
        id: foundUser?.id,
        email: foundUser?.email, // optional
        username: foundUser?.username, // optional
      });
    } else {
      // Unset when logged out or user unknown
      Sentry.setUser(null);
    }
  }, []);
};
